import React, {Component} from 'react';
import {Select} from "antd";
import {codeTables} from "../../codes";

const { Option } = Select;

function filterOption(inputValue, option) {
  return option.props.children.toString().toLowerCase().includes(inputValue.toString().toLowerCase());
}

export class CodeSingleSelect extends Component {
  // constructor(props) {
  //   super(props);
  // }

  render() {
    const {codes, ...props} = this.props;
    return (
      <Select
        showSearch
        filterOption={filterOption}
        {...props}
      >
        {codes.map(code => <Option value={code.code}>{code.name}</Option>)}
      </Select>
    );
  }
}

export class CodeSingleSelectFast extends Component {
  render() {
    const {table, ...props} = this.props;
    let codeTable = codeTables.get(table);
    return (
      <Select
        showSearch
        filterOption={filterOption}
        {...props}
      >
        {codeTable.map(code => <Option value={code.code}>{code.name}</Option>)}
      </Select>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Boilerplate/CodeSingleSelect.js